module.exports = __webpack_public_path__ + "img/logo.ded50e9e.svg";